/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ACCESSIBILITY = 'accessibility',
  ASSING_TERM = 'assing-term',
  COOKIE = 'cookie',
  COOKIE_POLICIES = 'cookie-policies',
  DASHBOARD = 'dashboard',
  DESCREDITED_PROVIDER = 'descredited-provider',
  DISCREDITED_PROVIDER_CARD_INFO = 'discredited-provider-card-info',
  DISCREDITED_PROVIDERS_DIALOG = 'discredited-providers-dialog',
  FOOTER = 'footer',
  FOOTER_NO_LOGIN = 'footer-no-login',
  FORM_REGISTER = 'form-register',
  HEALTH_DECLARATION_CANCELATION = 'health-declaration-cancelation',
  HEALTH_DECLARATION_DYNAMIC_FORM = 'health-declaration-dynamic-form',
  HEALTH_DECLARATION_FINALIZATION = 'health-declaration-finalization',
  HEALTH_DECLARATION_INVALID = 'health-declaration-invalid',
  HEALTH_DECLARATION_LANDING = 'health-declaration-landing',
  HEALTH_DECLARATION_VALID = 'health-declaration-valid',
  HEALTH_INSURANCE = 'health-insurance',
  HPMS_REPORTS_MODAL = 'hpms-reports-modal',
  INACTIVITY = 'inactivity',
  LOGIN = 'login',
  MAP_VIEW = 'map-view',
  MY_DATA = 'my-data',
  PDF_VIEWER = 'pdf-viewer',
  PRIVACY = 'privacy',
  PRODUCT_DATA = 'product-data',
  PRODUCT_LIST = 'product-list',
  PRODUCTS_BY_USER = 'products-by-user',
  REDIRECT = 'redirect',
  ROOT = 'root',
  ROUTES = 'routes',
  SOCIAL_NETWORK = 'social-network',
  TECHNICAL_VISIT = 'technical-visit',
  TECHNICAL_VISIT_DETAILS = 'technical-visit-details',
  TECHNICAL_VISIT_FORM = 'technical-visit-form',
}
export { FragmentNames };
